import { IMetric } from 'maps/metrics';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import getTableHeaders from './getTableHeaders';

import { RootState } from 'redux/rootReducer';
import { TTableHeader } from 'components/CustomizeView/CustomizeView';

const usePrepareCustomViewHeaders = (
  tableType: string,
  entity = 'item',
  tableHeadersType = 'standard'
): {
  availableHeaders: ({ label: string; value: string } | IMetric)[];
  savedHeaders: any[];
  formatHeaders: (header: TTableHeader) => TTableHeader;
} => {
  const tableAllHeaders = useMemo(
    () => getTableHeaders(entity, tableHeadersType),
    [entity, tableHeadersType]
  );
  const tableHeadersExcludedName: TTableHeader[] = useMemo(
    () =>
      tableAllHeaders.filter(
        (header: TTableHeader) => header.value !== 'displayName'
      ),
    [tableAllHeaders]
  );

  const savedTableHeaders: TTableHeader[] = useSelector(
    (state: RootState): any => (state.browseTable as any)[tableType]?.data || []
  );

  const formatHeaders = (header: TTableHeader): TTableHeader => {
    if (header.value === 'performance_wow_in_progress')
      header.label = 'Change (WTD)';
    if (header.value === 'performance_wow_last_completed')
      header.label = 'Change (LFW)';
    return header;
  };

  return {
    availableHeaders: tableHeadersExcludedName,
    savedHeaders: savedTableHeaders,
    formatHeaders,
  };
};

export default usePrepareCustomViewHeaders;
